<template>
<div class="template-wrapper" :style="getScale">
   <div class="template" id="canvas_template" :style="instanceJson.tmpl.view">
        <component 
            v-if="zones.length > 0"
            v-for="zone in zones"
            v-bind:is="zoneComponent(zone)"
            :zone="zone"
            :currScene="currScene"
            :hidden="isHiddenZone(zone)"
            :scale="scale"
            @click.native="handleZoneClicked(zone)"
            @removeAsset="handleRemoveAsset(zone)"
         ></component>

         <div class="video-box scoreboard-zone">
         </div>

         <div class="black-bg">
         </div>

         <div class="blue-box scoreboard-zone">
            <div class="scoreboard-text">Game Data</div>
         </div>
   </div>
</div>
</template>

<script>
import BaseSolonScoreboardTemplate from './../Solon/BaseSolonScoreboardTemplate'

export default {
   extends: BaseSolonScoreboardTemplate,
}

</script>